"use client";

import { useEffect } from "react";
import { useRouter, usePathname } from "next/navigation";
import { useConvexAuth, useQuery } from "convex/react";
import { api } from "@repo/backend/convex/_generated/api";
import { stashReturnUrl } from "@/lib/authRedirect";

export default function OnboardingRedirect() {
  const { isAuthenticated } = useConvexAuth();
  const onboarding = useQuery(api.onboarding.getMyOnboarding);
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (!isAuthenticated) return;
    if (onboarding === undefined) return; // loading

    // If the user has not completed onboarding, and they are not already on the
    // onboarding page, redirect them there. This should only happen once,
    // right after they sign up.
    if ((!onboarding || !onboarding.completed) && pathname !== "/onboarding") {
      // if user is mid-task when becoming authenticated, remember where they were
      if (pathname?.startsWith('/textbook') || pathname?.startsWith('/scholarship')) {
        stashReturnUrl(pathname + window.location.search + window.location.hash);
      }
      router.push("/onboarding");
    }
  }, [isAuthenticated, onboarding, pathname, router]);

  return null;
} 